// @flow
import { useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_MS = 400;

/**
 * The value as it stands once the caller has stopped changing it for `wait`.
 *
 * Trailing edge, unlike useDebouncedCallback: a query keyed on a free-text
 * field needs the value the agent finished typing, not the first keystroke.
 */
export default function useDebouncedValue<T>(
  value: T,
  wait: number = DEFAULT_DEBOUNCE_MS,
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), wait);

    return () => clearTimeout(timeout);
  }, [value, wait]);

  return debouncedValue;
}
